module.exports = __webpack_public_path__ + "static/media/pipe_down-sm.3bfcafc6.png";